module.exports = __webpack_public_path__ + "static/media/more-options-question-light.58014132.svg";